import * as _ from 'lodash';

import Banner from '../generic/Banner';
import type { ActiveBannerPlacement } from '../../hooks/api/banners/useActiveBanners';

import useActiveBanners from './useActiveBanners';

type Props = {
  placement?: ActiveBannerPlacement;
};

/**
 * In charge of rendering all active banners for the given placement.
 */
const BannerManager = ({ placement }: Props) => {
  const { banners, isLoading, error, onDismissBanner } = useActiveBanners(placement);
  if (isLoading || error) {
    return null;
  }

  return (
    <div className="banner-manager container">
      {banners.map(banner => (
        <Banner
          key={banner.id}
          title={banner.title}
          body={banner.renderedBody}
          bannerStyle={banner.style}
          isDismissible={banner.isDismissible}
          onDismiss={banner.isDismissible ? () => onDismissBanner(banner.id) : _.noop}
        />
      ))}
    </div>
  );
};

export default BannerManager;
